<mat-icon class="bs-icon">warning</mat-icon>
<div class="ngx-ui-error-message">{{errorMessage}}</div>
<div class="clear-both"></div>